export default [
  {
    name: 'ProvidersList',
    path: '/settings/providers',
    component: () => import('pages/settings/providers/ProvidersList.vue')
  },
  {
    name: 'ProvidersEdit',
    path: '/settings/providers/:id/edit',
    component: () => import('pages/settings/providers/ProvidersForm.vue')
  }
]
